"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isEicShopSubmitPostMessageDataV1 = exports.isEicAbortPostMessageData = void 0;
const ExchangeConfigurationV1_1 = require("../v1/ExchangeConfigurationV1");
const isEicAbortPostMessageData = (whatever) => {
    const data = whatever;
    return (data === null || data === void 0 ? void 0 : data.action) === 'abort';
};
exports.isEicAbortPostMessageData = isEicAbortPostMessageData;
const isEicShopSubmitPostMessageDataV1 = (whatever) => {
    var _a;
    const data = whatever;
    return (data === null || data === void 0 ? void 0 : data.action) === 'submit' && (0, ExchangeConfigurationV1_1.isExchangeConfigurationV1)((_a = data.payload) === null || _a === void 0 ? void 0 : _a.exchangeConfiguration);
};
exports.isEicShopSubmitPostMessageDataV1 = isEicShopSubmitPostMessageDataV1;
//# sourceMappingURL=eic-postmessage-payloads.js.map